import { createContext } from "react";
import { TimeZoneContextType } from "./TimeZoneContext.types";

export const TimeZoneContext = createContext<TimeZoneContextType>(
  {} as TimeZoneContextType,
);
